module.exports = __webpack_public_path__ + "static/media/shooter-logo.9b6a0ffe.png";